<template>
  <div>
    <v-dialog v-model="dialog" persistent width="800px">
      <v-card>
        <v-card-title class="bg-00A99D py-8">
          <v-row justify="center">
            <span class="text-white font-32 w-700 pl-5">Export To Excel</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false" small color="#FFFFFF" class="mr-3">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row class="my-5">
            <v-col cols="12" sm="6" md="6" align="center">
              <v-date-picker v-model="day_select" :max="dateNow" no-title range locale="th" color="#00A99D">
              </v-date-picker>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-col cols="12" class="py-0">
                <span class="font-16 text-navy-50">สถานะการลงทะเบียน</span>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-select hide-details="auto" solo dense placeholder="สถานะทั้งหมด" append-icon="mdi-chevron-down"
                  :menu-props="{ bottom: true, offsetY: true }" v-model="selectStatus_oneid"
                  :items="status_oneid" item-text="status_oneid" item-value="status_id"
                  color="#00A99D" item-color="teal darken-2">
                  <template slot="append">
                    <v-btn text icon>
                      <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" class="py-0">
                <span class="font-16 text-navy-50">บริการขนส่ง</span>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-select hide-details="auto" solo dense append-icon="mdi-chevron-down"
                  :menu-props="{ bottom: true, offsetY: true }" v-model="selectOrder_type"
                  :items="[...status_order_type, ...itemOrder_type]" item-text="status_order_type"
                  item-value="status_id" color="#00A99D" item-color="teal darken-2">
                  <template slot="append">
                    <v-btn text icon>
                      <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="dateRangeText" class="center" :value="displayDate()" label="ภายในช่วงเวลา"
                readonly color="#00A99D">
                  <template v-slot:prepend>
                    <v-icon color="#00A99D" class="mb-2" size="24">mdi-calendar</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-card-actions style="justify-content: center;">
                <v-btn depressed color="#00A99D" width="110px" style="border-radius: 20px 5px;" class="px-2 ml-2 py-5" :loading="btn_loading" @click="exportExcel()"
                    :disabled="day_select == ''">
                  <span class="text-white" style="text-transform: capitalize;">Export File</span>
                  <template v-slot:loader>
                    <span class="text-white">ดาวน์โหลด...</span>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import XLSX from "xlsx-js-style";
import moment from "moment";

export default {
  props: ["from"],
  data() {
    return {
      dialog: false,
      dateNow: moment().format("YYYY-MM-DD"),
      start_date: '',
      end_date: '',
      itemOrder_type: [],
      selectOrder_type: "",
      status_order_type: [
        { _id: "", status_order_type: "บริการขนส่งทั้งหมด", status_id: "" },
        { _id: "1", status_order_type: "Rider", status_id: 'rider' },
        { _id: "2", status_order_type: "Flash Express", status_id: 'flash' },
      ],
      day_select: [],
      selectStatus_oneid: "",
      status_oneid: [
        { _id: "", status_oneid: "สถานะการลงทะเบียนทั้งหมด", status_id: "" },
        { _id: "1", status_oneid: "ลงทะเบียน", status_id: 1 },
        { _id: "2", status_oneid: "ลงทะเบียนแทน", status_id: 2 },
      ],
      // =======================================================================
      select_start_date: "",
      select_end_date: "",
      clinic_name: sessionStorage.biz_name,
      itemTable:  [],
      total: 0,
      btn_loading: false,
    }
  },
  computed: {
    dateRangeText() {
      var start_year1 = ""
      var start_year2 = ""
      var end_year1 = ""
      var end_year2 = ""
      if (this.start_date > this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_year).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return  moment(this.end_date).locale("th").format("D MMMM " + end_year2)
                +" ~ "
                + moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else if (!this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_year).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return  moment(this.start_date).locale("th").format("D MMMM " + start_year2)
                +" ~ "
                + moment(this.end_date).locale("th").format("D MMMM" + end_year2)
      }
    },
  },
  methods: {
    openDialog(){
      this.day_select = []
      this.start_date = ""
      this.end_date = ""
      this.dateNow = moment().format("YYYY-MM-DD")
      this.itemOrder_type = []
      this.selectOrder_type = ""
      this.status_order_type = [
        { _id: "", status_order_type: "บริการขนส่งทั้งหมด", status_id: "" },
        { _id: "1", status_order_type: "Rider", status_id: 'rider' },
        { _id: "2", status_order_type: "Flash Express", status_id: 'flash' },
      ]
      this.selectStatus_oneid = ''
      this.status_oneid = [
        { _id: "", status_oneid: "สถานะการลงทะเบียนทั้งหมด", status_id: "" },
        { _id: "1", status_oneid: "ลงทะเบียน", status_id: 1 },
        { _id: "2", status_oneid: "ลงทะเบียนแทน", status_id: 2 },
      ],
      this.dialog = true
    },
    displayDate() {
      if (!this.day_select) return ''
      return (
        (this.start_date = this.day_select[0]),
        (this.end_date = this.day_select[1])
      );
    },
    exportExcel() {
      this.btn_loading = true
      if (this.from == "deliveryDrug") {
        this.getDeleveryDrug()
      } else if (this.from == "patientList") {
        this.getPatientsData()
      }
    },
    //  patientList ===============================================================================================
    getPatientsData() {
      try {
        this.loadingTable = true
        this.day_menu = false;

        let start = "";
        let end = "";
        if (this.day_select !== null && this.day_select !== undefined) {
          start = this.start_date;
          end = this.end_date;
        }

        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("status", 0);
        params.append("order_type", this.selectOrder_type || "")
        params.append("start_date", start || '');
        params.append("end_date", end || '');
        params.append("check_oneid_status", this.selectStatus_oneid || '');

        this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/pharma/get_regis_formdrug?${params}`).then(async (res) => {
          
          if (res.data.code == 200 && res.data.result == "success") {
            var item = res.data.data
            this.itemTable = item.data
            this.exportExcel_patientList(this.itemTable)
            setTimeout(() => {
              this.loadingTable = false;
            }, 3000);
          } else {
            const data = {
              title:
                "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
              icon: "error",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#3085d6",
            };
            setTimeout(() => {
              this.loadingTable = false;
              this.$refs.sweetDialog.open(data);
            }, 3000);
          }
        })
      } catch (error) {
        console.log("error", error);
        const data = {
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
          icon: "error",
          showConfirmButton: false,
          confirmButtonText: "ปิด",
          confirmButtonColor: "#3085d6",
        };
        setTimeout(() => {
          this.loadingTable = false;
          this.$refs.sweetDialog.open(data);
        }, 3000);
      }
    },
    async exportExcel_patientList(itemTable) {
      var safe = this;
      var start_date_th = await this.convertDate(this.start_date)
      var end_date_th = await this.convertDate(this.end_date)
      var title = [
                  {
                    key:
                      "ประวัติการลงทะเบียนรอรับยา" + this.clinic_name + " วันที่ " + this.showDateHeader()
                  },
                ];
      var header = [
        { 
          key1: "ลำดับ",
        },
      ];
      var wscols = [
        { wch: 10 }
      ];

      // set header xlsx =================================================================================
      // HN
      header[0][`key${Object.keys(header[0]).length + 1}`] = "HN";
      wscols.push({ wch: 20 })

      // ชื่อผู้ใช้บริการ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "ชื่อผู้ใช้บริการ";
      wscols.push({ wch: 20 })

      // วันที่ลงทะเบียน
      header[0][`key${Object.keys(header[0]).length + 1}`] = "วันที่ลงทะเบียน";
      wscols.push({ wch: 20 })

      // เบอร์โทรศัพท์ติดต่อ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "เบอร์โทรศัพท์ติดต่อ";
      wscols.push({ wch: 20 })

      // สถานะการลงทะเบียน
      header[0][`key${Object.keys(header[0]).length + 1}`] = "สถานะการลงทะเบียน";
      wscols.push({ wch: 20 })
      
      // วันเวลาที่สร้างออเดอร์
      header[0][`key${Object.keys(header[0]).length + 1}`] = "วันเวลาที่สร้างออเดอร์";
      wscols.push({ wch: 20 })

      // บริการขนส่ง
      header[0][`key${Object.keys(header[0]).length + 1}`] = "บริการขนส่ง";
      wscols.push({ wch: 20 })

       // น้ำหนัก (กรัม) 
      if (this.selectOrder_type == "flash" || this.selectOrder_type == "") {
        header[0][`key${Object.keys(header[0]).length + 1}`] = "น้ำหนัก (กรัม)";
        wscols.push({ wch: 20 })
      }

      // ขนาด (กว้าง x ยาว x สูง)
      if (this.selectOrder_type == "flash" || this.selectOrder_type == "") {
        header[0][`key${Object.keys(header[0]).length + 1}`] = "ขนาด (กว้าง x ยาว x สูง)";
        wscols.push({ wch: 20 })
      }

      // ที่อยู่จัดส่งยา
      header[0][`key${Object.keys(header[0]).length + 1}`] = "ที่อยู่จัดส่งยา";
      wscols.push({ wch: 20 })

      // หมายเหตุพัสดุ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "หมายเหตุพัสดุ";
      wscols.push({ wch: 20 })

      // สถานะ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "สถานะ";
      wscols.push({ wch: 20 })

      // =================================================================================================

      var table_body = [];
      itemTable.forEach((ele, index) => {

        var dataJson = {}

        // NO
        dataJson["NO"] = index + 1

        // เลขออเดอร์
        if(Object.values(header[0]).indexOf('เลขออเดอร์') != -1) {
          dataJson["order_number"] = "-"
        }
        // HN
        if(Object.values(header[0]).indexOf('HN') != -1) {
          dataJson["HN"] = ele.cardHN
        }
        
        // ชื่อผู้ใช้บริการ
        if(Object.values(header[0]).indexOf('ชื่อผู้ใช้บริการ') != -1) {
          dataJson["user_name"] = ele.firstname + " " + ele.lastname
        }

        // วันที่ลงทะเบียน
        if(Object.values(header[0]).indexOf('วันที่ลงทะเบียน') != -1) {
          dataJson["user_createdAt"] = this.convertDate(ele.data_user.createdAt)
        }

        // เบอร์โทรศัพท์ติดต่อ
        if(Object.values(header[0]).indexOf('เบอร์โทรศัพท์ติดต่อ') != -1) {
          dataJson["mobile"] = ele.mobile
        }

        // สถานะการลงทะเบียน
        if(Object.values(header[0]).indexOf('สถานะการลงทะเบียน') != -1) {
          dataJson["oneid_status"] = ele.oneid_status == 1 ? 'ลงทะเบียน' : 'ลงทะเบียนแทน'
        }

        // วันเวลาที่สร้างออเดอร์
        if(Object.values(header[0]).indexOf('วันเวลาที่สร้างออเดอร์') != -1) {
          dataJson["createdAt"] =  "วันที่ " + this.showDate(ele.createdAt) +" " + "เวลา " + this.showTime(ele.createdAt) + " น."
        }

        // บริการขนส่ง
        if(Object.values(header[0]).indexOf('บริการขนส่ง') != -1) {
          dataJson["order_type"] = this.showRider(ele.order_type)
        }

        // น้ำหนัก (กรัม)
        if(Object.values(header[0]).indexOf('น้ำหนัก (กรัม)') != -1) {
          if(ele.order_type == "flash" && "Parcel_Option_Detail" in ele && ele.Parcel_Option_Detail !== null && "weight" in  ele.Parcel_Option_Detail ){
            dataJson["weight"] = ele.Parcel_Option_Detail.weight
          } else {
            dataJson["weight"] =  "-"
          }
        }

        // ขนาด (กว้าง x ยาว x สูง)
        if(Object.values(header[0]).indexOf('ขนาด (กว้าง x ยาว x สูง)') != -1) {
          dataJson["size_box"] = this.showBoxSize(ele)
        }

        // ที่อยู่จัดส่งยา
        if(Object.values(header[0]).indexOf('ที่อยู่จัดส่งยา') != -1) {
          dataJson["address"] = 'address' in ele ? ele.address : '-'
        }

        // หมายเหตุพัสดุ
        if(Object.values(header[0]).indexOf('หมายเหตุพัสดุ') != -1) {
          dataJson["note"] = this.showNote(ele)
        }

        // สถานะ
        if(Object.values(header[0]).indexOf('สถานะ') != -1) {
          dataJson["status"] = this.showStatusPatients(ele)
        }

        table_body.push(dataJson);
      });

        const dataWS = XLSX.utils.json_to_sheet(title, {
          skipHeader: true,
          origin: "B2",
        });
        XLSX.utils.sheet_add_json(dataWS, header, {
          skipHeader: true,
          origin: "A4",
        });
        XLSX.utils.sheet_add_json(dataWS, table_body, {
          skipHeader: true,
          origin: "A5",
        });


        //set style
        dataWS["B2"].s = {
          font: {
            bold: true,
            sz: 12,
          },
        };
        // Set the style for header
        for (let col = 0; col < Object.keys(header[0]).length; col++) {
          const cellRef = XLSX.utils.encode_cell({ r: 3, c: col });
          const cell = dataWS[cellRef];
          if (col == 0) {
            cell.s = {
              font: {
                bold: true,
              },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
            };
          } else if (col == Object.keys(header[0]).length - 1) {
            cell.s = {
              font: {
                bold: true,
              },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
            };
          } else {
            cell.s = {
              font: {
                bold: true,
              },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
            };
          }
        }
        //set width column
        dataWS["!cols"] = wscols;


        
        const wb = XLSX.utils.book_new();
    
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(
          wb,
          `ประวัติการลงทะเบียนรอรับยา ${start_date_th} ถึง ${end_date_th}.xlsx`
        );
        
        setTimeout(() => (
          safe.btn_loading = false,
          safe.dialog = false
        ), 2000)
      
    },
    // end patientList ============================================================================================
    async getDeleveryDrug() {
      try {
        let start = "";
        let end = "";
        if (this.day_select !== null && this.day_select !== undefined) {
          if (this.start_date > this.end_date) {
            start = this.end_date;
            end = this.start_date;
          } else {
            start = this.start_date;
            end = this.end_date;
          }
        }

        var params = new URLSearchParams;
        params.append('biz_id', sessionStorage.getItem("biz_id"))
        params.append('state', 0)
        params.append('order_type', this.selectOrder_type)
        params.append("start_date", start || '');
        params.append("end_date", end || '');
        params.append("check_oneid_status", this.selectStatus_oneid || '');

        await this.axios.get(process.env.VUE_APP_BACKEND_URL+`/v1/transport/get_transport_data?${params}`)
        .then( async (res) => {
          if(res.data.result == 'success') {
            this.itemTable = res.data.data.data
            await this.exportExcel_deliveryDrug(this.itemTable)
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async exportExcel_deliveryDrug(itemTable) {
      var safe = this;
      var start_date_th = await this.convertDate(this.start_date)
      var end_date_th = await this.convertDate(this.end_date)
      var title = [
                  {
                    key:
                      "ประวัติการรอรับยาของ" + this.clinic_name + " วันที่ " + this.showDateHeader()
                  },
                ];
      var header = [
        { 
          key1: "ลำดับ",
        },
      ];
      var wscols = [
        { wch: 15 }
      ];
      // set header xlsx =================================================================================

      // เลขออเดอร์
      header[0][`key${Object.keys(header[0]).length + 1}`] = "เลขออเดอร์";
      wscols.push({ wch: 20 })

      // ชื่อผู้ใช้บริการ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "ชื่อผู้ใช้บริการ";
      wscols.push({ wch: 20 })

      // HN
      header[0][`key${Object.keys(header[0]).length + 1}`] = "HN";
      wscols.push({ wch: 20 })

      // วันที่ลงทะเบียน
      header[0][`key${Object.keys(header[0]).length + 1}`] = "วันที่ลงทะเบียน";
      wscols.push({ wch: 20 })

      // เบอร์โทรศัพท์ติดต่อ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "เบอร์โทรศัพท์ติดต่อ";
      wscols.push({ wch: 20 })

      // สถานะการลงทะเบียน
      header[0][`key${Object.keys(header[0]).length + 1}`] = "สถานะการลงทะเบียน";
      wscols.push({ wch: 20 })

      // วันเวลาที่สร้างออเดอร์
      header[0][`key${Object.keys(header[0]).length + 1}`] = "วันเวลาที่สร้างออเดอร์";
      wscols.push({ wch: 20 })

       // แพทย์/เจ้าหน้าที
      header[0][`key${Object.keys(header[0]).length + 1}`] = "แพทย์/เจ้าหน้าที";
      wscols.push({ wch: 20 })

      // บริการขนส่ง
      header[0][`key${Object.keys(header[0]).length + 1}`] = "บริการขนส่ง";
      wscols.push({ wch: 20 })

       // น้ำหนัก (กรัม) 
      if (this.selectOrder_type == "flash") {
        header[0][`key${Object.keys(header[0]).length + 1}`] = "น้ำหนัก (กรัม)";
        wscols.push({ wch: 20 })
      }

      // ขนาด (กว้าง x ยาว x สูง)
      if (this.selectOrder_type == "flash") {
        header[0][`key${Object.keys(header[0]).length + 1}`] = "ขนาด (กว้าง x ยาว x สูง)";
        wscols.push({ wch: 20 })
      }

      // ที่อยู่จัดส่งยา
      header[0][`key${Object.keys(header[0]).length + 1}`] = "ที่อยู่จัดส่งยา";
      wscols.push({ wch: 20 })

      // หมายเหตุพัสดุ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "หมายเหตุพัสดุ";
      wscols.push({ wch: 20 })

      // สถานะ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "สถานะ";
      wscols.push({ wch: 20 })

      // วัน-เวลา จัดส่งพัสดุสำเร็จ
      header[0][`key${Object.keys(header[0]).length + 1}`] = "วัน-เวลา จัดส่งพัสดุสำเร็จ";
      wscols.push({ wch: 20 })

      // ค่าจัดส่ง
      header[0][`key${Object.keys(header[0]).length + 1}`] = "ค่าจัดส่ง";
      wscols.push({ wch: 20 })

      // สิทธิการรักษา
      // header[0][`key${Object.keys(header[0]).length + 1}`] = "สิทธิการรักษา";
      // wscols.push({ wch: 20 })

      // สถานะ conference
      header[0][`key${Object.keys(header[0]).length + 1}`] = "สถานะ conference";
      wscols.push({ wch: 20 })

      // วัน-เวลาที่ conference
      header[0][`key${Object.keys(header[0]).length + 1}`] = "วัน-เวลาที่ conference";
      wscols.push({ wch: 20 })

      // หมายเหตุ conference
      header[0][`key${Object.keys(header[0]).length + 1}`] = "หมายเหตุ conference";
      wscols.push({ wch: 20 })

      // =================================================================================================

      var table_body = [];
      itemTable.forEach((ele, index) => {
        console.log(ele);

        var dataJson = {}

        // ลำดับ
        dataJson["NO"] = index + 1

        // เลขออเดอร์
        if(Object.values(header[0]).indexOf('เลขออเดอร์') != -1) {
          dataJson["order_number"] = ele.reference_id || "-"
        }
        
        // ชื่อผู้ใช้บริการ
        if(Object.values(header[0]).indexOf('ชื่อผู้ใช้บริการ') != -1) {
          dataJson["user_name"] = ele.name_th
        }

        // HN
        if(Object.values(header[0]).indexOf('HN') != -1) {
          dataJson["HN"] = ele.user_HN
        }

        // วันที่ลงทะเบียน
        if(Object.values(header[0]).indexOf('วันที่ลงทะเบียน') != -1) {
          dataJson["user_createdAt"] = this.convertDate(ele.user_created_at)
        }

        // เบอร์โทรศัพท์ติดต่อ
        if(Object.values(header[0]).indexOf('เบอร์โทรศัพท์ติดต่อ') != -1) {
          dataJson["mobile"] = ele.user_mobile
        }

        // สถานะการลงทะเบียน
        if(Object.values(header[0]).indexOf('สถานะการลงทะเบียน') != -1) {
          dataJson["oneid_status"] = ele.oneid_status == 1 ? 'ลงทะเบียน' : 'ลงทะเบียนแทน'
        }

        // วันเวลาที่สร้างออเดอร์
        if(Object.values(header[0]).indexOf('วันเวลาที่สร้างออเดอร์') != -1) {
          dataJson["createdAt"] =  "วันที่ " + this.showDate(ele.order_date) +" " + "เวลา " + this.showTime(ele.order_date) + " น."
        }

        // แพทย์/เจ้าหน้าที่
        if(Object.values(header[0]).indexOf('แพทย์/เจ้าหน้าที') != -1) {
          dataJson["name_staff"] = this.checkNameStaff(ele)
        }

        // บริการขนส่ง
        if(Object.values(header[0]).indexOf('บริการขนส่ง') != -1) {
          dataJson["order_type"] = this.showRider(ele.order_type)
        }

        // น้ำหนัก (กรัม)
        if(Object.values(header[0]).indexOf('น้ำหนัก (กรัม)') != -1) {
          if(ele.order_type == "flash" && "flash_item" in ele && ele.flash_item !== null && "weight" in  ele.flash_item ){
            dataJson["weight"] = ele.flash_item.weight
          } else {
            dataJson["weight"] =  "-"
          }
        }

        // ขนาด (กว้าง x ยาว x สูง)
        if(Object.values(header[0]).indexOf('ขนาด (กว้าง x ยาว x สูง)') != -1) {
          dataJson["size_box"] = this.showBoxSize(ele)
        }

        // ที่อยู่จัดส่งยา
        if(Object.values(header[0]).indexOf('ที่อยู่จัดส่งยา') != -1) {
          dataJson["address"] =  this.showAddress(ele)
        }

        // หมายเหตุพัสดุ
        if(Object.values(header[0]).indexOf('หมายเหตุพัสดุ') != -1) {
          dataJson["note"] = this.showNoteOrder(ele)
        }

        // สถานะ
        if(Object.values(header[0]).indexOf('สถานะ') != -1) {
          dataJson["status"] = this.showStatus(ele)
        }

        // วัน-เวลา จัดส่งพัสดุสำเร็จ
        if(Object.values(header[0]).indexOf('วัน-เวลา จัดส่งพัสดุสำเร็จ') != -1) {
          dataJson["date_status_finish"] = this.showDateStatusFinish(ele)
        }
        
        // ค่าจัดส่ง
        if(Object.values(header[0]).indexOf('ค่าจัดส่ง') != -1) {
          dataJson["shipping_cost"] = this.showCOD(ele)
        }
        
        // สิทธิการรักษา
        if(Object.values(header[0]).indexOf('สิทธิการรักษา') != -1) {
          dataJson["medical_rights"] = this.medical_rights_show(ele.department)
        }

        // สถานะ conference
        if(Object.values(header[0]).indexOf('สถานะ conference') != -1) {
          dataJson["status_conference"] = this.showStatusConference(ele.note_conference)
        }
        // วัน-เวลาที่ conference
        if(Object.values(header[0]).indexOf('วัน-เวลาที่ conference') != -1) {
          dataJson["date_Conference"] = this.showDateCon(ele.note_conference)
        }
        
        // หมายเหตุ conference
        if(Object.values(header[0]).indexOf('หมายเหตุ conference') != -1) {
          dataJson["note_conference"] = this.showDateCon(ele.note_conference)
        }

        table_body.push(dataJson);
      });

        const dataWS = XLSX.utils.json_to_sheet(title, {
          skipHeader: true,
          origin: "B2",
        });
        XLSX.utils.sheet_add_json(dataWS, header, {
          skipHeader: true,
          origin: "A4",
        });
        XLSX.utils.sheet_add_json(dataWS, table_body, {
          skipHeader: true,
          origin: "A5",
        });


        //set style
        dataWS["B2"].s = {
          font: {
            bold: true,
            sz: 12,
          },
        };
        // Set the style for header
        for (let col = 0; col < Object.keys(header[0]).length; col++) {
          const cellRef = XLSX.utils.encode_cell({ r: 3, c: col });
          const cell = dataWS[cellRef];
          if (col == 0) {
            cell.s = {
              font: {
                bold: true,
              },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
            };
          } else if (col == Object.keys(header[0]).length - 1) {
            cell.s = {
              font: {
                bold: true,
              },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
            };
          } else {
            cell.s = {
              font: {
                bold: true,
              },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
            };
          }
        }
        //set width column
        dataWS["!cols"] = wscols;


        
        const wb = XLSX.utils.book_new();
    
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(
          wb,
          `ประวัติการรอรับยา ${start_date_th} ถึง ${end_date_th}.xlsx`
        );

        setTimeout(() => (
          safe.btn_loading = false,
          safe.dialog = false
        ), 2000)

    },
    
    showDateHeader() {
      var start_year1 = ""
      var start_year2 = ""
      var end_year1 = ""
      var end_year2 = ""
      if (this.start_date > this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.end_date).locale("th").format("D MMMM " + end_year2)
              + " - "
              + moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else if (!this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM " + start_year2) 
               + " - "
               + moment(this.end_date).locale("th").format("D MMMM " + end_year2) 
      }
    },
    convertDate(time = "") {
      var year1 = ""
      var year2 = ""
      year1 = moment(time).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(time).locale("th").format("DD/MM/" + year2);
    },
    showDate(item) {
      var year1 = ""
      var year2 = ""
      year1 = moment(item).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(item).locale("th").format("DD/MM/" + year2)
    },
    showTime(item) {
      return moment(item)
        .locale("TH")
        .format("LT");
    },
    showStatusConference(item) {
      if (item.length === 0) {
        return 'ไม่สำเร็จ'
      } else {
        return 'สำเร็จ'
      }
    },
    showDateStatusFinish(item){
      if (item.order_type === 'flash' && 'flash_status9' in item && item.flash_status9.statusDateTime !== '' && item.flash_status9.statusDateTime !== undefined && item.flash_status9.statusDateTime !== null) {
        var year1 = ""
        var year2 = ""
        year1 = moment(item.flash_status9.statusDateTime).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return 'วันที่ ' + moment(item.flash_status9.statusDateTime).locale("th").format("DD/MM/" + year2) + ' เวลา ' + moment(item.flash_status9.statusDateTime).locale("TH").format("LT") + ' น.'
      } else {
        return '-'
      }
    },
    showDateCon(item) {
      var year1 = ""
      var year2 = ""
      if (item.length === 0) {
        return '-'
      } else {
        var date = item[item.length - 1].created_at
        year1 = moment(date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(date).locale("th").format("วันที่ DD/MM/"+year2+" เวลา LT น.")
      }
    },
    showNoteCon(item) {
      if (item.length === 0) {
        return '-'
      } else {
        var note = item[item.length - 1].note
        return note;
      }
    },
    showStatus(item) {
      if (item.order_type === 'rider') {
        if (item.status == "N" || item.status == "1") {
          return "เตรียมยา";
        } else if (item.status == "4") {
          return "กำลังหาคนขับ";
        } else if (item.status == "5") {
          return "มีคนขับแล้ว";
        } else if (item.status == "6") {
          return "กำลังไปรับพัสดุ";
        } else if (
          "status7R" in item &&
          item.status == "7" &&
          item.job_type == "R"
        ) {
          return "คนขับถึงจุดรับ";
        } else if (item.status == "8") {
          return "กำลังนำส่ง";
        } else if (
          "status7D" in item &&
          item.status == "7" &&
          item.job_type == "D"
        ) {
          return "คนขับถึงที่หมายเรียบร้อย";
        } else if (item.status == "9") {
          return "จัดส่งสำเร็จ";
        } else if (item.status == "0") {
          return "ยกเลิก";
        } else {
          return "-";
        }
      } else {
        if ('flash_status1' in item && item.status == '1' || item.status == 'N') {
          return "เตรียมยา";
        } else if ('flash_status5' in item && item.status == '5') {
          return "เรียกขนส่งมารับ";
        } else if ('flash_status6' in item && item.status == '6') {
          return "พนักงานรับพัสดุแล้ว";
        } else if ('flash_status15' in item && item.status == '15') {
          return "มีการยืนยันน้ำหนักและขนาดมาจากผู้ขนส่ง";
        } else if ('flash_status16' in item && item.status == '16') {
          return "มีการยืนยันราคาค่าขนส่งมาจากผู้ขนส่ง";
        } else if ('flash_status7' in item && item.status == '7') {
          return "พัสดุอยู่ระหว่างการขนส่งจากสาขาต้นทางไปสาขาปลายทาง";
        } else if ('flash_status8' in item && item.status == '8') {
          return "พัสดุถึงสาขาปลายทางอยู่ระหว่างการจัดส่ง";
        } else if ('flash_status11' in item && item.status == '11') {
          return "ไม่สามารถติดต่อผู้รับได้ พัสดุตีกลับสาขาปลายทาง รอจัดส่งใหม่อีกครั้ง";
        } else if ('flash_status9' in item && item.status == '9') {
          return "จัดส่งสำเร็จ";
        } else if ('flash_status0' in item && item.status == '0') {
          return "ยกเลิก";
        } else {
          return "-";
        }
      }
    },
    showCOD(item) {
      if (item.order_type === 'flash' && 'flash_item' in item && 'cod_amount' in item.flash_item ) {
        return parseFloat(item.flash_item.cod_amount)
      } else {
        return parseFloat(item.delivery_cost_amount)
      }
    },
    showStatusPatients(item) {
      if (item.status == "1") {
        return "ลงทะเบียน";
      } else if (item.status == "2" && 'flow_type' in item && item.flow_type === 'telemed') {
        return "อยู่ระหว่างดำเนินการ";
      } else if (item.status == "2") {
        return "อยู่ระหว่างจัดส่ง";
      } else if (item.status == "3") {
        return "เสร็จสิ้น";
      } else if (item.status == "4") {
        return "ยกเลิก";
      } else {
        return "-";
      }
      
    },
    checkNameStaff(item) {
      if ('staff_first_name' in item || 'staff_last_name' in item) {
        return item.staff_first_name + " " + item.staff_last_name
      } else {
        return '-'
      }
    },
    showStatusDepartment(item) {
      if (typeof (item) === 'string') {
        return item;
      } else if (item.length !== 0) {
        return item.toString()
      } else {
        return "-";
      }
    },
    showRider(item) {
      if (item == "rider") {
        return "Rider";
      } else if (item == "flash") {
        return "Flash";
      } else {
        return '-'
      }
    },

    showBoxSize(item) {
      if (item.order_type == "flash") {
        if (  "Parcel_Option_Detail" in item 
          && item.Parcel_Option_Detail !== null 
          && "box_size" in  item.Parcel_Option_Detail 
          && "weight" in  item.Parcel_Option_Detail 
          && "length" in  item.Parcel_Option_Detail
          && "height" in  item.Parcel_Option_Detail 
          ) {
          return item.Parcel_Option_Detail.box_size + ' (' +  item.Parcel_Option_Detail.width + ' x ' + item.Parcel_Option_Detail.length + ' x ' + item.Parcel_Option_Detail.height + ')'
        } else if ( "Parcel_Option_Detail" in item 
          && item.Parcel_Option_Detail !== null 
          && "weight" in  item.Parcel_Option_Detail 
          && "length" in  item.Parcel_Option_Detail
          && "height" in  item.Parcel_Option_Detail
          ) {
            return '(' +  item.Parcel_Option_Detail.width + ' x ' + item.Parcel_Option_Detail.length + ' x ' + item.Parcel_Option_Detail.height + ')'
        } else if ( "flash_item" in item 
          && item.flash_item !== null 
          && "box_size" in  item 
          && "weight" in  item.flash_item 
          && "length" in  item.flash_item
          && "height" in  item.flash_item 
          ) {
            return item.flash_item.box_size + ' (' +  item.flash_item.width + ' x ' + item.flash_item.length + ' x ' + item.flash_item.height + ')'
        } else if ( "flash_item" in item 
          && item.flash_item !== null 
          && "weight" in  item.flash_item 
          && "length" in  item.flash_item
          && "height" in  item.flash_item 
         ) {
          return item.flash_item.box_size + ' (' +  item.flash_item.width + ' x ' + item.flash_item.length + ' x ' + item.flash_item.height + ')'
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    showNoteOrder(item) {
      if ('note_order' in item && item.note_order !== '') {
        return item.note_order
      } else {
        return '-'
      }
    },
    showNote(item) {
      if ('note' in item && item.note !== '') {
        return item.note
      } else {
        return '-'
      }
    },
    medical_rights_show(item) {
      if ('medical_rights' in item && item.medical_rights !== undefined && item.medical_rights !== null) {
        if ('medical_rights_name' in item.medical_rights && item.medical_rights.medical_rights_name !== undefined && item.medical_rights.medical_rights_name !== null) {
          if (item.medical_rights.medical_rights_name == 'อื่นๆ' && 'medical_rights_name_other' in item.medical_rights && item.medical_rights.medical_rights_name_other !== undefined && item.medical_rights.medical_rights_name_other !== null) {
            return item.medical_rights.medical_rights_name_other
          } else {
            return item.medical_rights.medical_rights_name
          }
        } else {
           return '-'
        }
      } else {
        return '-'
      }
    },
    showAddress(item) {
      if(item.order_type == "rider") {
        if (item.reference_item.length !== 0 && 'address' in item.reference_item[1] ) {
          return item.reference_item[1].address
        } else {
          return "-"
        }
      } else if (item.order_type == "flash") {
        if ("flash_item" in item && 'dst_address' in item.flash_item ) {
          return item.flash_item.dst_address
        } else {
          return "-"
        }
      } else {
        return "-"
      }
    },
  }
}
</script>

<style scoped>
::v-deep .center .v-input__slot {
  text-align-last: center !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select.v-input--dense .v-select__selection--comma {
  line-height: 2rem !important;
}
</style>